import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse, ApiListResponse } from '../lib/response';

import { ContentTemplate } from '../models/contentTemplate';
import type { ContentTemplateType } from '../models/contentTemplate';

export class ContentTemplateService extends BaseService<ContentTemplate> {
  override model = ContentTemplate;
  override modelName = 'contentTemplate';
  override modelLabel = 'Content Template';

  override async list({
    page = 1,
    filters = {},
  }: {
    page?: number;
    limit?: number;
    search?: string;
    filters?: Record<string, any>;
    sort?: { key: string; direction: 'asc' | 'desc' };
    modifiedSince?: Date;
  } = {}): Promise<ApiListResponse<ContentTemplate>> {
    const query: Record<string, string> = { page: page.toString() };

    for (const [key, value] of Object.entries(filters)) {
      if (value !== null) {
        query[key] = String(value);
      }
    }

    const request = new ApiRequest({
      method: 'GET',
      url: this.modelBaseUrl,
      query,
    });

    return await this.requestList(request, ContentTemplate);
  }

  async preview(
    contentTemplate: ContentTemplate,
  ): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/preview`,
      data: contentTemplate.toJSON(),
    });

    return await this.request(request);
  }

  async getDefaults(type: ContentTemplateType): Promise<ApiResponse<ContentTemplate>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}/new`,
      query: { type: String(type) },
    });

    return await this.requestItem(request, ContentTemplate);
  }
}
